import * as types from "./types";

const initialState = {
  isFetching: false,
  currentLocale: "",
  translations: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_LOCALE_REQUEST:
      return { ...state, isFetching: true, currentLocale: action.locale };
    case types.FETCH_LOCALE_SUCCESS:
      return {
        isFetching: false,
        currentLocale: action.locale,
        translations: action.translations
      };
    case types.FETCH_LOCALE_FAILURE:
      return { ...state, isFetching: false };
    default:
      return state;
  }
};
